import { twClassMerge } from '@healthhub/react-ui';
import { Button } from 'antd';


import type { IRetriveDataErrorAlertBodyProps } from './RetrieveDataErrorAlertBody.types';
import styles from './RetriveDataErrorAlertBody.module.css';

const RetriveDataErrorAlertBody = ({
  alertTitle,
  hideHeader,
  message,
  onRefresh,
  refreshButtonText,
  buttonClassName,
  alertBodyClassName,
}: IRetriveDataErrorAlertBodyProps) => {
  const title = alertTitle ?? 'We are having problems retrieving the following records:';
  return (
    <>
      {!hideHeader && <h4 className={styles.alertErrorTitle}>{title}</h4>}
      <div className={twClassMerge(styles.retrieveDataErrorAlertBody, alertBodyClassName)}>
        {!!message && <div className={styles.retrieveDataErrorAlertText}>{message}</div>}

        {!!onRefresh && (
          <Button
            className={twClassMerge(styles.refreshErrorAlertButton, buttonClassName)}
            onClick={onRefresh}
            type="text"
          >
            {refreshButtonText ?? 'Refresh'}
          </Button>
        )}
      </div>
    </>
  );
};

export default RetriveDataErrorAlertBody;
